module.exports = __webpack_public_path__ + "static/image4-17a9ce93f83004380c7741ef95ae7e5b.png";